<template>
    <div class="storage-card" :class="{ connected: storage.status, disconnected: !storage.status }">
        <div class="status">
            <div :class="['status-container', storage.status ? 'status-container-conn' : 'status-container-disconn']">
                <div :class="['status-dot', storage.status ? 'connected-dot' : 'disconnected-dot']">
                </div>
                {{ storage.status ? 'Connected' : 'Not Connected' }}
            </div>
            <div>
                <SimpleMenu :menuList="storageMenu">
                    <template #menuButton>
                        <vs-button class="custm-more-icon">
                            <img src="@/assets/images/menu.svg" />
                        </vs-button>
                    </template>
                </SimpleMenu>
            </div>
        </div>

        <h3>{{ storage.name }}</h3>
        <p><span class="storage-label-light">Storage Type: </span><strong>{{ storage.provider.type
        }}</strong></p>
        <p>
            <span class="storage-label-light">Storage: </span>
            <span :class="!storage.deActive ? 'enabled' : 'disabled'">
                {{ !storage.deActive ? 'Enabled' : 'Disabled' }}
            </span>
        </p>

        <div class="storage-con">
            <div class="provider">
                <img :src="getProviderImage()" :alt="`${storage.provider.name} logo`" class="w-8 h-8 object-contain" />
                <span>{{ storage.provider.name }}</span>
            </div>
            <div class="str-config-label" @click="handleUpdateConfig">{{storage.deActive ? "Enable storage" : "Disable storage"}}</div>
        </div>

        <!-- Edit Storage Modal -->
        <EditStorageModal v-if="activeModal === 'editStorageModal'" :closeModal="() => activeModal = ''"
            :storage="storage" :fetchStorages="fetchStorages" />
        <!-- Delete Storage Modal -->
        <DeleteStorageModal v-if="activeModal === 'deleteStorageModal'" :closeModal="() => activeModal = ''"
            :storage="storage" :fetchStorages="fetchStorages" />
        <!-- Disable Storage Modal -->
        <DisableStorageModal v-if="activeModal === 'disableStorageModal'" :closeModal="() => activeModal = ''"
            :storage="storage" :fetchStorages="fetchStorages"/>
    </div>
</template>

<script>
import SimpleMenu from '@/components/common/simpleMenu/SimpleMenu.vue';
import EditStorageModal from './EditStorageModal.vue';
import DeleteStorageModal from './DeleteStorageModal.vue';
import sia from '@/assets/images/sia.png';
import swarm from '@/assets/images/swarm.png';
import cloud from '@/assets/images/cloud.png';
import aws from '@/assets/images/aws.png';
import DisableStorageModal from './DisableStorageModal.vue';

export default {
    name: 'StorageCard',
    props: ['storage', 'index', 'fetchStorages'],
    components: {
        SimpleMenu,
        EditStorageModal,
        DeleteStorageModal,
        DisableStorageModal,
    },
    data() {
        return {
            activeModal: '',
            storageMenu: [
                {
                    label: "Configure",
                    icon: () => import("@/assets/svgs/menu-icons/setting.vue"),
                    onClick: () => this.openEditStorageModal(),
                },
                {
                    label: "Delete",
                    icon: () => import("@/assets/svgs/menu-icons/storagedelete.vue"),
                    onClick: () => this.openDeleteStorageModal(),
                },
                // {
                //     label: "Explorer",
                //     icon: () => import("@/assets/svgs/menu-icons/folder.vue"),
                //     onClick: () => this.openFileExplorer(),
                // },
            ]
        };
    },
    methods: {
        getProviderImage() {
            const localImages = {
                'Sia': sia,
                'Swarm': swarm,
                'AWS S3': aws,
                'Decast': cloud,
            };
            return localImages[this.storage.provider.name] || this.storage.provider.image || 'https://via.placeholder.com/32'; // Fallback image
        },
        openEditStorageModal() {
            this.activeModal = 'editStorageModal';
        },
        openDeleteStorageModal() {
            this.activeModal = 'deleteStorageModal';
        },
        openFileExplorer() {
        },
        handleUpdateConfig() {
            this.activeModal = 'disableStorageModal';
        },
        closeStorageModal() {
            this.activeModal = '';
        },
    },
};
</script>

<style scoped>
* {
    font-family: 'JetBrains Mono', monospace !important;
}

.storage-card {
    border-top: 1px solid #FFFFFF;
    border-left: 1px solid #FFFFFF;
    border-right: 3px solid #FFFFFF;
    border-bottom: 3px solid #FFFFFF;
    background: #0A0B0F;
    padding: 1rem;
    transition: 0.3s;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.custm-more-icon {
    background-color: transparent !important;
    border: none !important;
}

.status-container {
    padding: 5px 10px;
    border-radius: 20px;
    display: flex;
    align-items: center;
}

.status-container-conn {
    color: #22C55E;
    background-color: #22C55E20;
}

.status-container-disconn {
    color: #EF4444;
    background-color: #EF444420;
}

.storage-card h3 {
    color: #FFFFFF;
    margin-bottom: 0.5rem;
}

.storage-label-light {
    color: #545454;
}

.status {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: space-between;
}

.status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 8px;
}

.connected-dot {
    background-color: #22C55E;
}

.disconnected-dot {
    background-color: #EF4444;
}

.enabled {
    color: #22c55e;
}

.disabled {
    color: #a3a3a3;
}

.storage-con {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #545454;
}
.str-config-label {
    color: #D7DF23;
    cursor: pointer;
}
.provider {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: bold;
}
</style>